import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {AddPatientAbsencePriInfoField} from '../add-patient-absence-pri-info-field/AddPatientAbsencePriInfoField'
import {InputSelectPatient} from '@/features/patients/components/input-select-patient/InputSelectPatient'
import {useFormContext, Controller, useWatch} from 'react-hook-form'
import {AddPatientAbsenceFormValidationSchema} from '../../formSchemas'
import {CommunicatedOnTimeField} from '../communicated-on-time-field/CommunicatedOnTimeField'
import {CommunicatedAttachmentsField} from '../communicated-attachments-field/CommunicatedAttachmentsField'
import {useGetAgendaEventsCount} from '../../queries/useGetAgendaEventsCount'
import {formatDate} from '@/dayjs'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {AddPatientAbsenceDatesFields} from '../add-patient-absence-dates-field/AddPatientAbsenceDatesFields'

export const AddPatientAbsenceFields = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<AddPatientAbsenceFormValidationSchema>()
    const patientsWatch = useWatch({control, name: 'patients'})
    const startDateWatch = useWatch({control, name: 'startDate'})
    const endDateWatch = useWatch({control, name: 'endDate'})
    const communicatedOnTimeWatch = useWatch({control, name: 'communicatedOnTime'})
    const {data: eventsCount, isLoading: isEventsCountLoading} = useGetAgendaEventsCount(
        {
            therapists: [],
            patients: [patientsWatch && patientsWatch[0]?.id],
            startDate: formatDate(startDateWatch),
            endDate: formatDate(endDateWatch)
        },
        {enabled: !!patientsWatch && !!patientsWatch[0]?.id && !!startDateWatch && !!endDateWatch}
    )

    return (
        <Grid columns={2} columnGap={4} rowGap={6}>
            <Controller
                control={control}
                name="patients"
                render={({field, fieldState}) => (
                    <InputSelectPatient
                        label={t('commons:patient')}
                        placeholder={t('commons:select_patient')}
                        value={field.value && field.value[0]}
                        hideBadge
                        onChange={value => field.onChange([value])}
                        errorMessage={fieldState.error?.message}
                    />
                )}
            />
            <AddPatientAbsencePriInfoField
                patientId={patientsWatch && patientsWatch[0]?.id}
                patientName={patientsWatch && patientsWatch[0]?.fullName}
            />
            <GridItem spanColumn={2}>
                <AddPatientAbsenceDatesFields />
            </GridItem>
            <GridItem spanColumn={2}>
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('agenda:scheduled_events_count')}
                    </Text>
                    {isEventsCountLoading ? (
                        <Skeleton width={50} height={20} />
                    ) : eventsCount?.numberOfEvents ? (
                        <Text palette="neutral" shade="950" size="textSm" weight="500">
                            {eventsCount?.numberOfEvents}
                        </Text>
                    ) : (
                        <Text palette="neutral" shade="500" size="textSm">
                            -
                        </Text>
                    )}
                </DetailsField>
            </GridItem>
            <GridItem spanColumn={2}>
                <CommunicatedOnTimeField />
            </GridItem>
            {communicatedOnTimeWatch && communicatedOnTimeWatch === 'within_48_hours' && (
                <CommunicatedAttachmentsField />
            )}
        </Grid>
    )
}
